export const BACKDROP_SETTLE_MS = 400;

export const BackdropSettleMixin = {
  data() {
    return { backdropSettled: false, backdropSettleTimer: null };
  },
  beforeUnmount() {
    clearTimeout(this.backdropSettleTimer);
  },
  methods: {
    settleBackdrop() {
      clearTimeout(this.backdropSettleTimer);
      this.backdropSettled = false;
      this.backdropSettleTimer = setTimeout(() => {
        this.backdropSettled = true;
      }, BACKDROP_SETTLE_MS);
    },
  },
};
